import React from 'react';
import { Box, Card, CardHeader, CardContent, Stack, Tabs, Tab } from '@mui/material';

import Scrollbar from '../../../../../components-core/Scrollbar';
import { EventForm } from './EventForm';
import Iconify from '../../../../../components-core/Iconify';

export const FullScreenView = props => {
  const { data, submitCallback, handleClose, allSeasons, allResorts, allAgeRanges, allCamps } = props;
  const [currentTab, setCurrentTab] = React.useState(0);

  return (
    <Scrollbar>
      { currentTab === 0
        ? <Box display="flex" flexDirection="row" justifyContent="space-between" mt={1} mr={2}>
          <Stack flex="1 1 70%">
            <Card>
              <CardHeader title={data ? 'Edytuj zajęcia' : 'Dodaj zajęcia'} sx={{ mt: -1, mb: -2 }} />
              <CardContent>
                <EventForm
                  data={data}
                  submitCallback={submitCallback}
                  handleClose={handleClose}
                  allSeasons={allSeasons}
                  allResorts={allResorts}
                  allAgeRanges={allAgeRanges}
                  allCamps={allCamps} />
              </CardContent>
            </Card>
          </Stack>
        </Box>
        : <Box>asd</Box>}
    </Scrollbar>
  );
};
